export const seasonBasedPriceDiscount = 2;
export const numberOfDays_Taken_To_Auto_Accept_Order_After_Delivery = 7;
export const MAX_FILE_SIZE_MB = 20; // Max file size in MB
export const ORDER_TOPIC_MAX_LENGTH = 200;

export const roles = {
    ADMIN: "ADMIN",
    USER: "USER",
    WRITER: "WRITER"
};

export const threadStatus = {
    ACTIVE: "ACTIVE",
    INACTIVE: "INACTIVE",
};

export const systemNotifications = {
    ORDER_CREATED: "Your order has been successfully created.",
    REQUIREMENT_SUBMITTED: "Your order requirements have been submitted.",
    PENDING_PAYMENT:
        "Your order is awaiting payment. Please complete payment to continue.",
    INPROGRESS_ORDER: "Your Order is now in progress.",
    ORDER_DELIVERED:
        "Your order has been delivered. Please review and accept the delivery.",
    ORDER_ACCEPTED:
        "Your order has been marked as completed. Thank you for using our service.",
    ORDER_COMPLETED_BY_ADMIN:
        "Your order has been marked as completed by the admin. Thank you for using our service.",
    ORDER_AUTO_ACCEPTED:
        "Your order completed automatically after 7 days since delivery.",
    REQUEST_REVISION:
        "Your Review has been received. We will review it and respond shortly. .",
    COMPLAINET_RAISED:
        "Your complaint has been received. We will review it and respond shortly.",
    COMPLAINET_RESOLVED:
        "Your complaint has been resolved.",
    THANK_YOU_FOR_YOUR_PATIENCE: "Thank you for your patience."
};

export const providers = {
    LOCAL: "LOCAL",
    GOOGLE: "GOOGLE",
};

export const orderStatus = {
    REQUIREMENTS_SUBMITTED: "REQUIREMENTS_SUBMITTED",
    PENDING_PAYMENT: "PENDING_PAYMENT",
    PENDING_WRITER: "PENDING_WRITER",
    ORDER_IN_PROGRESS: "ORDER_IN_PROGRESS",
    ORDER_DELIVERED: "ORDER_DELIVERED",
    IN_REVISION: "IN_REVISION",
    COMPLETED: "COMPLETED",
    COMPLAINT_RAISED: "COMPLAINT_RAISED",
    RESOLVED: "RESOLVED",
    CANCELLED: "CANCELLED"
};

export const reviewStatus = {
    ACTIVE: "ACTIVE",
    COMPLETED: "COMPLETED",
};

export const resolvedReasons = {
    REFUND: "Issue resolved with a refund",
    REVISION_PROVIDED: "Revision provided and approved by the client",
    MISUNDERSTANDING: "Misunderstanding clarified and resolved",
    COPLAINT_WITHDREW: "Client withdrew the complaint",
    NO_ACTION_REQUIRED: "No further action required; issue deemed invalid",
    COMPENSATION: "Compensation offered and accepted",
    MUTUAL_AGREEMENT: "Complaint resolved through mutual agreement"
}

// multipliers
export const TYPE_OF_PAPERS_MULTIPLIERS = [
  { name: "Admission Essay", paperTypeMultiplier: 1 },
  { name: "Analytical Essay", paperTypeMultiplier: 1 },
  { name: "Annotated Bibliography", paperTypeMultiplier: 1 },
  { name: "Annotated Outline", paperTypeMultiplier: 1 },
  { name: "Application/Admission Essay", paperTypeMultiplier: 1 },
  { name: "Argumentative Essay", paperTypeMultiplier: 1 },
  { name: "Article Critique", paperTypeMultiplier: 1 },
  { name: "Article Review", paperTypeMultiplier: 1 },
  { name: "Article Summary", paperTypeMultiplier: 1 },
  { name: "Blog Post", paperTypeMultiplier: 1 },
  { name: "Book Report", paperTypeMultiplier: 1 },
  { name: "Book Review", paperTypeMultiplier: 1 },
  { name: "Book/Movie Review", paperTypeMultiplier: 1 },
  { name: "Business Plan", paperTypeMultiplier: 1 },
  { name: "Capstone Project", paperTypeMultiplier: 1 },
  { name: "Case Study", paperTypeMultiplier: 1 },
  { name: "Cause and Effect Essay", paperTypeMultiplier: 1 },
  { name: "Compare and Contrast Essay", paperTypeMultiplier: 1 },
  { name: "Cover Letter", paperTypeMultiplier: 1 },
  { name: "Coursework", paperTypeMultiplier: 1 },
  { name: "Creative Writing", paperTypeMultiplier: 1 },
  { name: "Critique/Article Review", paperTypeMultiplier: 1 },
  { name: "Debate Speech", paperTypeMultiplier: 1 },
  { name: "Descriptive Essay", paperTypeMultiplier: 1 },
  { name: "Discussion Post", paperTypeMultiplier: 1 },
  { name: "Dissertation", paperTypeMultiplier: 1.5 },
  { name: "Essay (Any type)", paperTypeMultiplier: 1 },
  { name: "Executive Brief", paperTypeMultiplier: 1 },
  { name: "Expository Essay", paperTypeMultiplier: 1 },
  { name: "Grant Proposal", paperTypeMultiplier: 1 },
  { name: "Infographic", paperTypeMultiplier: 1.5 },
  { name: "Lab Report", paperTypeMultiplier: 1 },
  { name: "Learning Journal", paperTypeMultiplier: 1 },
  { name: "Literary Analysis", paperTypeMultiplier: 1 },
  { name: "Literature Review", paperTypeMultiplier: 1.5 },
  { name: "Marketing Plan", paperTypeMultiplier: 1 },
  { name: "Memo (Memorandum)", paperTypeMultiplier: 1 },
  { name: "Movie Review", paperTypeMultiplier: 1 },
  { name: "Narrative Essay", paperTypeMultiplier: 1 },
  { name: "Nursing Care Plan", paperTypeMultiplier: 1 },
  { name: "Persuasive Essay", paperTypeMultiplier: 1 },
  { name: "Personal Statement", paperTypeMultiplier: 1 },
  { name: "Policy Paper", paperTypeMultiplier: 1 },
  { name: "Position Paper", paperTypeMultiplier: 1 },
  { name: "Poster Presentation", paperTypeMultiplier: 1 },
  { name: "Powerpoint", paperTypeMultiplier: 1 },
  { name: "Press Release", paperTypeMultiplier: 1 },
  { name: "Presentation Script", paperTypeMultiplier: 1 },
  { name: "Project Proposal", paperTypeMultiplier: 1 },
  { name: "Reflection Paper", paperTypeMultiplier: 1 },
  { name: "Reflective Journal", paperTypeMultiplier: 1 },
  { name: "Report (General)", paperTypeMultiplier: 1 },
  { name: "Research Paper", paperTypeMultiplier: 1 },
  { name: "Research Proposal", paperTypeMultiplier: 1 },
  { name: "Research Summary", paperTypeMultiplier: 1 },
  { name: "Resume/CV", paperTypeMultiplier: 1 },
  { name: "Response Paper", paperTypeMultiplier: 1 },
  { name: "SOAP Note", paperTypeMultiplier: 1 },
  { name: "Speech", paperTypeMultiplier: 1 },
  { name: "Statement of Purpose", paperTypeMultiplier: 1 },
  { name: "Systematic Review", paperTypeMultiplier: 1.5 },
  { name: "SWOT Analysis", paperTypeMultiplier: 1 },
  { name: "Term Paper", paperTypeMultiplier: 1 },
  { name: "Thesis", paperTypeMultiplier: 1.5 },
  { name: "White Paper", paperTypeMultiplier: 1 },
  { name: "Question-Answer", paperTypeMultiplier: 1 }
];


export const WRITING_TYPES_MULTIPLIERS = [
    { name: "Writing from scratch", writingTypeMultiplier: 1 },
    { name: "Editing", writingTypeMultiplier: 0.5 },
    { name: "AI Humanization", writingTypeMultiplier: 0.5 },
    { name: "Remove AI Content (Humanize)", writingTypeMultiplier: 0.5 },
    { name: "Rewriting", writingTypeMultiplier: 0.6 },
]

export const TYPE_OF_ENGLISH_MULTIPLIERS = [
    { id: 1, name: "US English", englishTypeMultiplier: 1 },
    { id: 2, name: "UK English", englishTypeMultiplier: 1.1 },
    { id: 3, name: "Australia English", englishTypeMultiplier: 1.1 },
]

//identifiers
export const ACADEMIC_LEVEL_IDENTIFIERS = {
    COLLEGE: "College",
    UNIVERSITY: "University",
    MASTERS: "Masters",
    DOCTORATE: "Doctorate"
}

export const WRITING_TYPES_IDENTIFIERS = {
    WRITING_FROM_SCRATCH: "Writing from scratch",
    EDITING:  "Editing",
    REMOVE_AI_CONTENT:"AI Humanization",
    REWRITING: "Rewriting", 
}

export const TYPE_OF_ENGLISH_INDETIFIERS = {
    US_ENGLISH: "US English",
    UK_ENGLISH: "UK English", 
    AUSTRALIA_ENGLISH: "Australia English",
}

export const SPACING_OPTIONS = {
  DOUBLE_SPACING: {
    label: "Double Spacing",
    multiplier: 1,
  },
  ONE_POINT_FIVE_SPACING: {
    label: "1.5 Spacing",
    multiplier: 1.5,
  },
  SINGLE_SPACING: {
    label: "Single Spacing",
    multiplier: 2,
  },
};

export const ADITIONAL_SERVICES_PRICE_CAL_TYPES = {
    PER_PAGE: 1,
    PERCENTAGE_PER_PAGECOST: 2,
    PERCENTAGE_PER_TOTALCOST: 3,
    FIXED: 4,
    FREE: 5,
    PAGE_PERCENTAGE_WITH_MULTIPLIER: 6
}

export const ADITIONAL_SERVICE_LABELS = {
  ABSTRACT: "Abstract",
  EXEC_SUMMARY: "Executive Summary",
  PROOFREAD: "Proofread by Editor",
  FIGURES: "Figures/Charts",
  TOC: "Table of Contents",
  DRAFT: "Draft",
  SPECIFIC_WRITER: "Request Specific Writer",
  TURNITIN_AI: "Turnitin AI Report",
  SIMILARITY_AI: "Turnitin Similarity Report"
};

export const TURNITIN_REPORT_TOOLTIP = "We use Turnitin's no repository option; so, your paper won't be stored in Turnitin's database.";


export const ADITIONAL_SERVICES_PRICE_CAL_FUNCTIONS = {
  [ADITIONAL_SERVICE_LABELS.PROOFREAD]: ({ pages }) => 4 * pages,
  [ADITIONAL_SERVICE_LABELS.FIGURES]: ({ pagePrice, perPageMultiplier }) => 0.5 * pagePrice * perPageMultiplier,
  [ADITIONAL_SERVICE_LABELS.TOC]: ({ pagePrice }) => 0.5 * pagePrice,
  [ADITIONAL_SERVICE_LABELS.DRAFT]: ({ totalCost }) => 0.15 * totalCost,
  [ADITIONAL_SERVICE_LABELS.SPECIFIC_WRITER]: ({ totalCost }) => 0.15 * totalCost,
  [ADITIONAL_SERVICE_LABELS.ABSTRACT]: () => 20 ,
  [ADITIONAL_SERVICE_LABELS.EXEC_SUMMARY]: () => 20,
  [ADITIONAL_SERVICE_LABELS.TURNITIN_AI]: () => 0,
  [ADITIONAL_SERVICE_LABELS.SIMILARITY_AI]: () => 0, 
};

export const ADITIONAL_SERVICES = [
  {
    label: ADITIONAL_SERVICE_LABELS.ABSTRACT,
    costType: ADITIONAL_SERVICES_PRICE_CAL_TYPES.FIXED,
    isAvailable: true,
    icon: "material-symbols:draw-abstract",
    calculate: ADITIONAL_SERVICES_PRICE_CAL_FUNCTIONS[ADITIONAL_SERVICE_LABELS.ABSTRACT],
    note: "Includes a concise summary of your paper",
    cost: "20$",
    tooltip: "Adds a brief summary of the paper's purpose, method, and main points."
  },
  {
    label: ADITIONAL_SERVICE_LABELS.EXEC_SUMMARY,
    costType: ADITIONAL_SERVICES_PRICE_CAL_TYPES.FIXED,
    isAvailable: true,
    icon: "material-symbols:summarize",
    calculate: ADITIONAL_SERVICES_PRICE_CAL_FUNCTIONS[ADITIONAL_SERVICE_LABELS.EXEC_SUMMARY],
    note: "Brief overview highlighting points",
    cost: "20$",
    tooltip: "Adds a short overview of the key findings, arguments, and recommendations."
  },
  {
    label: ADITIONAL_SERVICE_LABELS.PROOFREAD,
    costType: ADITIONAL_SERVICES_PRICE_CAL_TYPES.PER_PAGE,
    icon: "mage:edit-pen-fill",
    calculate: ADITIONAL_SERVICES_PRICE_CAL_FUNCTIONS[ADITIONAL_SERVICE_LABELS.PROOFREAD],
    note: "Expert review for errors and clarity",
    isAvailable: true,
    cost: "4$/page",
    tooltip: "Checks grammar, spelling, punctuation, and sentence clarity before delivery."    
  },
  {
    label: ADITIONAL_SERVICE_LABELS.DRAFT,
    costType: ADITIONAL_SERVICES_PRICE_CAL_TYPES.PERCENTAGE_PER_TOTALCOST,
    calculate: ADITIONAL_SERVICES_PRICE_CAL_FUNCTIONS[ADITIONAL_SERVICE_LABELS.DRAFT],
    isAvailable: ({ daysUntilDeadline }) => daysUntilDeadline >= 2,
    icon: "fluent:drafts-24-filled",
    note: "Receive a draft version before final",
    cost: "15% × totalCost",
    tooltip: "Receive an early draft before the final version so you can review progress."
  },
  {
    label: ADITIONAL_SERVICE_LABELS.TURNITIN_AI,
    costType: ADITIONAL_SERVICES_PRICE_CAL_TYPES.FREE,
    calculate: ADITIONAL_SERVICES_PRICE_CAL_FUNCTIONS[ADITIONAL_SERVICE_LABELS.TURNITIN_AI],
    note: "To check AI content - Paper won't be stored on Turnitin's database",
    isAvailable: true,
    icon: "material-symbols:content-copy",
    cost: "Free",
    tooltip: TURNITIN_REPORT_TOOLTIP
  },
  {
    label: ADITIONAL_SERVICE_LABELS.SIMILARITY_AI,
    costType: ADITIONAL_SERVICES_PRICE_CAL_TYPES.FREE,
    calculate: ADITIONAL_SERVICES_PRICE_CAL_FUNCTIONS[ADITIONAL_SERVICE_LABELS.SIMILARITY_AI],
    note: "Check plagiarism - Paper won't be stored on Turnitin's database",
    isAvailable: true,
    icon: "material-symbols:content-copy",
    cost: "Free",
    tooltip: TURNITIN_REPORT_TOOLTIP
  },
  {
    label: ADITIONAL_SERVICE_LABELS.FIGURES,
    costType: ADITIONAL_SERVICES_PRICE_CAL_TYPES.PAGE_PERCENTAGE_WITH_MULTIPLIER,
    isAvailable: true,
    icon: "mdi:chart-line",
    calculate: ADITIONAL_SERVICES_PRICE_CAL_FUNCTIONS[ADITIONAL_SERVICE_LABELS.FIGURES],
    note: "Visualize data with professional charts",
    inputName: "numberOfFigures",
    isAnabledInput: true,
    inputPlaceholder: "Enter Number Of Figures",
    inputType: "number",
    inputProps: {
      min: 1,
      max: 50,
      step: 1,
    },
    cost: "50% × pageCost",
    perPageMultiplierName: "numberOfFigures",
    tooltip: "Adds charts, graphs, or figures based on your paper's data or instructions."
  },
  {
    label: ADITIONAL_SERVICE_LABELS.SPECIFIC_WRITER,
    costType: ADITIONAL_SERVICES_PRICE_CAL_TYPES.PERCENTAGE_PER_TOTALCOST,
    calculate: ADITIONAL_SERVICES_PRICE_CAL_FUNCTIONS[ADITIONAL_SERVICE_LABELS.SPECIFIC_WRITER],
    note: "Select your preferred expert writer",
    icon: "streamline:ai-edit-spark-solid",
    inputName: "requestedWriterId",
    isAnabledInput: true,
    inputPlaceholder: "Enter writer's ID e.g. IDxxxx",
    isAvailable: true,
    inputType: "text",
    cost: "15% × totalCost",
    tooltip: "Request a specific writer by ID, subject to availability."
  },
  {
    label: ADITIONAL_SERVICE_LABELS.TOC,
    costType: ADITIONAL_SERVICES_PRICE_CAL_TYPES.PERCENTAGE_PER_PAGECOST,
    icon: "material-symbols:menu-book",
    calculate: ADITIONAL_SERVICES_PRICE_CAL_FUNCTIONS[ADITIONAL_SERVICE_LABELS.TOC],
    note: "Organise paper sections with TOC",
    isAvailable: true,
    cost: "50% × pageCost",
    tooltip: "Adds a table of contents listing the paper's main sections and page numbers."
  },
];


export const WORDS_PER_PAGE = {
    [SPACING_OPTIONS.SINGLE_SPACING.label]: 550,
    [SPACING_OPTIONS.DOUBLE_SPACING.label]: 275,
    //TODO: need to chanage this value
    [SPACING_OPTIONS.ONE_POINT_FIVE_SPACING.label]: 350
}


export const typeOfPapers = [
  "Admission Essay",
  "Analytical Essay",
  "Annotated Bibliography",
  "Annotated Outline",
  "Application/Admission Essay",
  "Argumentative Essay",
  "Article Critique",
  "Article Review",
  "Article Summary",
  "Blog Post",
  "Book Report",
  "Book Review",
  "Business Plan",
  "Capstone Project",
  "Case Study",
  "Cause and Effect Essay",
  "Compare and Contrast Essay",
  "Cover Letter",
  "Coursework",
  "Creative Writing",
  "Debate Speech",
  "Descriptive Essay",
  "Discussion Post",
  "Dissertation",
  "Essay (Any type)",
  "Executive Brief",
  "Expository Essay",
  "Grant Proposal",
  "Infographic",
  "Lab Report",
  "Learning Journal",
  "Literary Analysis",
  "Literature Review",
  "Marketing Plan",
  "Memo (Memorandum)",
  "Movie Review",
  "Narrative Essay",
  "Nursing Care Plan",
  "Persuasive Essay",
  "Personal Statement",
  "Policy Paper",
  "Position Paper",
  "Poster Presentation",
  "Powerpoint",
  "Press Release",
  "Presentation Script",
  "Project Proposal",
  "Question-Answer",
  "Reflection Paper",
  "Reflective Journal",
  "Report (General)",
  "Research Paper",
  "Research Proposal",
  "Research Summary",
  "Resume/CV",
  "Response Paper",
  "SOAP Note",
  "Speech",
  "Statement of Purpose",
  "SWOT Analysis",
  "Systematic Review",
  "Term Paper",
  "Thesis",
  "White Paper"
];


export const academicLevels = [
    "College",
    "University",
    "Masters",
    "Doctorate",
];

export const deadlines = [
    "21 days",
    "14 days",
    "10 days",
    "06 days",
    "04 days",
    "02 days",
    "24 hours",
    "12 hours",
    "06 hours",
    "03 hours",
];

export const DEADLINES = [
    { name: "21 days", value: 21 },
    { name: "14 days", value: 14 },
    { name: "10 days", value: 10 },
    { name: "06 days", value: 6 },
    { name: "04 days", value: 4 },
    { name: "02 days", value: 2 },
    { name: "24 hours", value: 1 },
    { name: "12 hours", value: 0.5 },
    { name: "06 hours", value: 0.25 },
    { name: "03 hours", value: 0.125 },
]

export const spacings = [
    "Double Spacing",
    "Single Spacing",
];

export const referenceStyles = [
    "MLA",
    "APA",
    "Chicago",
    "Harvard",
    "Turabian",
    "Writer's Choice",
    "Not Applicable"
];

export const writerExperience = [
    "No Experience before",
    "Less than one year",   
    "1 - 2 years",
    "More than 2 years" 
]

export const paymentMethods = {
    PAYPAL: "PAYPAL",
    WALLET: "WALLET",
    WALLET_PAYPAL: "WALLET_PAYPAL"
}

export const writerStatus = {
    ACTIVE: "ACTIVE",
    RESIGN: "RESIGN"
}

export const contactMethods = [
    "email",
    "phone"
]

export const preferedResolution = [
    "Refund",
    "Revision",
    "Explanation/Clarification",
    "Compensation"
]

export const referencesFormats = {
    // "image/jpeg": [],
    // "image/png": [],
    // "image/jpg": [],
    // "application/pdf": [],
    // "application/msword": [],
    // "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [], // .xlsx
    // "text/csv": [], // .csv
    // "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [], // .docx
    // "application/vnd.openxmlformats-officedocument.presentationml.presentation": [], // .pptx
    // "text/plain": [], // .txt
    
    "image/jpeg": [], // .jpeg
    "image/png": [],  // .png
    "image/jpg": [],  // .jpg
    "application/pdf": [], // .pdf
    "application/msword": [], // .doc
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [], // .docx
    "application/vnd.ms-excel": [], // .xls
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [], // .xlsx
    "application/vnd.ms-powerpoint": [], // .ppt
    "application/vnd.openxmlformats-officedocument.presentationml.presentation": [], // .pptx
    "text/csv": [], // .csv
    "text/plain": [], // .txt
    "application/zip": [".zip"], // .zip
    "application/x-zip-compressed": [".zip"],
    "application/vnd.rar": [".rar"], // .rar
    "application/x-rar-compressed": [".rar"],
    "application/x-7z-compressed": [".7z"]
}

export const tooltips = {
  WRITING_TYPES: "Choose the service you need: new writing, editing, or humanizing existing text.",
  PAPER_TYPE: "Select the assignment type so we can follow the right format and structure.",
  ACADEMIC_LEVEL: "Choose the level that matches your course so we assign the right expertise.",
  ENGLISH_TYPE: "Choose US, UK, or Australian English. UK and Australian English add 10% to the price.",
  DEADLINE: "Shorter deadlines cost more. Longer deadlines usually lower the price.",
  SPACING: "Double spacing is standard. Single spacing fits more words per page and costs more.",
  PRESENTATION: "You can add slides to this paper. However, if you need slides only, choose Powerpoint as the paper type.",
  SUBJECT: "Select the closest subject. If it is not listed, choose Other Subject.",
  TOPIC: "Optional. Leave this blank if you want the writer to choose a suitable topic.",
  INSTRUCTIONS: "Add the requirements, rubric details, sources, and points the writer must cover.",
  CITATION_STYLE: "Select the required citation style, or choose Not applicable if none is needed.",
  UPLOADS: "Upload rubrics, samples, notes, or source files. Maximum file size is 20MB.",
  
  // Tooltips for the client dashboard
  WALLET_BALANCE: "The current available balance in your wallet.",
  PENDING_AMOUNT: "Funds for uncompleted orders. Will only be released to the writer if you accept the order."
};
